import request from '@/libs/request';

// 获取审查意见状态
export const getNodeCodesList = (data) => {
  return request({
    url: '/workorder/management/serviceNode/serverNodeWithFunctionCode',
    data,
    method: 'post',
  });
};

// 获取审查意见列表
export const getListApi = (data) => {
  return request({
    url: '/workorder/client/trademarkOaWork/trademarkOaPage',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

// 获取审查意见详情
export const getDetailsApi = (data) => {
  return request({
    url: `/workorder/management/trademarkOaWork/info/${data.workId}`,
    // data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

// 获取审查意见详情
export const getDetailsClientApi = (data) => {
  return request({
    url: `/workorder/client/trademarkOaWork/info/${data.workId}`,
    // data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

//根据ID关闭oa工单
export const trademarkOaWorkTrademarkOaWorkOrderClose = (data) => {
  return request({
    url: '/workorder/client/trademarkOaWork/trademarkOaWorkOrderClose',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

//获取汇率
export const getRealRate = (data) => {
  return request({
    url: '/payment/payMerchant/get/real/rate/list',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

//获取审查意见类型列表
export const trademarkBasedataList = (data) => {
  return request({
    url: '/workorder/management/trademarkBaseData/list',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};



// WEBPACK FOOTER //
// ./src/api/trademarkRegister/reviewOpinions.js